/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveSecureContainerData } from './eve-secure-container.data';
import { IEveSecureContainerProps } from './eve-secure-container.props.autogenerated';

export interface IEveSecureContainerViewProps extends IEveSecureContainerProps<IEveSecureContainerData> {}

/**
 *
 * EveSecureContainer component
 * @extends {React.PureComponent<IEveSecureContainerProps<IEveSecureContainerData>>}
 */
class EveSecureContainer extends React.PureComponent<IEveSecureContainerProps<IEveSecureContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default EveSecureContainer;
